import { BullhornListTypes, BullhornNamespace } from 'datasource-service-lib';
import { IWorkflowService } from 'interfaces-lib';
import { IPreMergeChecker } from '../../interfaces/ipremergechecker';
import { IMergeBasketViewConfig } from '../../merge-basket-view/merge-basket-view.component';
import { ServiceProviderService } from '../service.provider.service';
import { BullhornFileToPathConverter } from './bullhorn.filetopathconverter';
import { BullhornPreMergeCheck } from './bullhorn.premergecheck';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

export class BullhornMergeBasketViewConfig implements IMergeBasketViewConfig {
  readonly namespace = BullhornNamespace.name;
  readonly workflowService: IWorkflowService;
  readonly entityType = undefined;
  readonly fileType = undefined;
  readonly fileToPathConverter = new BullhornFileToPathConverter(BullhornListTypes.FileAttachments);
  readonly preMergeChecker: IPreMergeChecker;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProvider: SharedServiceProviderServiceFactory) {
    this.workflowService = serviceProviderService.getWorkflowService(BullhornNamespace.name);
    this.preMergeChecker = new BullhornPreMergeCheck(serviceProviderService, sharedServiceProvider);
  }
}
